import { render, staticRenderFns } from "./HomepageItem.vue?vue&type=template&id=3dae7f78&"
import script from "./HomepageItem.vue?vue&type=script&lang=js&"
export * from "./HomepageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports